import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { CURRENCIES, currencySearchText } from "../lib/currencies";
// Deliberately share the country selector's surfaces, spacing and focus styles.
import "./CountryCodeSelect.css";

export default function CurrencySelect({ value, onValueChange, onChange, portalCurrency, id, label = "Moneda", disabled = false, className = "", modal = false, "data-testid": testId }) {
  const [open, setOpen] = useState(false);
  const code = String(value || "").toUpperCase();
  const selected = CURRENCIES.find(currency => currency.code === code);
  // Preserve existing/custom trip values; never silently replace them with COP.
  const options = !selected && code ? [{ code, name: "Moneda guardada" }, ...CURRENCIES] : CURRENCIES;
  return (
    <Popover open={open} onOpenChange={setOpen} modal={modal}>
      <PopoverTrigger asChild>
        <button id={id} type="button" role="combobox" disabled={disabled} aria-expanded={open}
          aria-label={`${label}: ${code || "Seleccionar"}${selected ? ` — ${selected.name}` : ""}`}
          data-testid={testId} className={`aorra-country-trigger min-w-0 disabled:opacity-50 ${className}`}>
          <span className="shrink-0 font-semibold">{code}</span>
          <span className="min-w-0 flex-1 truncate text-left">{selected?.name || (code ? "Moneda guardada" : "Selecciona moneda")}</span>
          <ChevronDown className="h-4 w-4 shrink-0 text-[#545454]" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={8} collisionPadding={16}
        className="aorra-country-popover p-0" style={{ zIndex: 10050 }} aria-label="Seleccionar moneda">
        <Command className="aorra-country-command" filter={(option, search) => currencySearchText(option).includes(currencySearchText(search)) ? 1 : 0}>
          <CommandInput placeholder="Código de moneda (EUR, USD…)" aria-label="Buscar moneda por código o nombre" />
          <CommandList className="aorra-country-list">
            <CommandEmpty>No encontramos esa moneda.</CommandEmpty>
            <CommandGroup>
              {options.map(currency => (
                <CommandItem key={currency.code} value={`${currency.code} ${currency.name}`}
                  className="aorra-country-option" data-current={currency.code === code}
                  onSelect={() => { (onValueChange || onChange)?.(currency.code); setOpen(false); }}>
                  <span className="w-10 shrink-0 font-semibold">{currency.code}</span>
                  <span className="min-w-0 flex-1 break-words">{currency.name}{currency.code === portalCurrency ? " · Moneda del portal" : ""}</span>
                  <span className="w-4 shrink-0">{currency.code === code && <Check className="h-4 w-4" aria-hidden="true" />}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
